import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Box from '@mui/material/Box';
import PreprimarySidebar2025 from '../PreprimarySidebar2025/PreprimarySidebar2025';


const KGStoryTelling2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });



  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2025}/home/events-activities/pre-primary/KgStoryTelling/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/events-activities/pre-primary/KgStoryTelling/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/events-activities/pre-primary/KgStoryTelling/3.webp`;
  const p4 = `${config.base_image_url_2025}/home/events-activities/pre-primary/KgStoryTelling/4.webp`;
  const p5 = `${config.base_image_url_2025}/home/events-activities/pre-primary/KgStoryTelling/5.webp`;
  const p6 = `${config.base_image_url_2025}/home/events-activities/pre-primary/KgStoryTelling/6.webp`;
  const p7 = `${config.base_image_url_2025}/home/events-activities/pre-primary/KgStoryTelling/7.webp`;
  const p8 = `${config.base_image_url_2025}/home/events-activities/pre-primary/KgStoryTelling/8.webp`;
  const p9 = `${config.base_image_url_2025}/home/events-activities/pre-primary/KgStoryTelling/9.webp`;
  const p10 = `${config.base_image_url_2025}/home/events-activities/pre-primary/KgStoryTelling/10.webp`;

 

  const photos = [
    
{
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
},
{
    src: p7,
    source: p7,
    rows: 1,
    cols: 1,
},
{
    src: p8,
    source: p8,
    rows: 1,
    cols: 1,
},
{
    src: p9,
    source: p9,
    rows: 1,
    cols: 1,
},
{
    src: p10,
    source: p10,
    rows: 1,
    cols: 1,
}


    // {
    //   src: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   source: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      Story Telling Activity
        </Typography>
        <Typography fontSize = "x-small"><br/><br/>
         Class: PRE-PRIMARY (Kindergarten)  Date: 16 Junuary 2026 
        </Typography>

        <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
        “Storytelling Activity – Where Little Voices Weaved Big Wonders” <br/>
        </Typography>


         <Typography
          variant={'h6'}
          color={'primary'}
          align={'left'}
          fontWeight={'normal'}
        ><br/>
        “Every child is a storyteller and every story is a window into imagination.” <br/>
        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        Our Kindergarten classrooms blossomed with creativity and joy during the Storytelling Activity held on Friday, 16 January 2026. With sparkling eyes and confident little voices, children stepped forward to share stories on thoughtfully chosen themes where children travelled through magical lands, oceans, gardens and skies, meeting talking animals, tiny helpers and brave little heroes. Shaped by imagination, emotions and meaningful values, each narration reflected curiosity and creativity, transforming the learning spaces into hubs of wonder and expression.  
       <br></br>
        The experience gently nurtured language skills, confidence and expressive abilities, encouraging children to communicate their thoughts with clarity and pride. Guided by supportive teachers and surrounded by encouraging peers, every child felt heard, appreciated and celebrated.
        <br></br>
        This special event also highlighted the strength of the home–school partnership. The enthusiastic involvement of parents in preparing the students with their creative props added warmth and encouragement, making the experience even more meaningful for our young learners. Together, we created a joyful environment where imagination flourished and little voices truly wove big wonders.
       <br></br>
         <br></br>
        </Typography>
      </Box>
      <Typography
          variant={'h5'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “Where imagination speaks and stories come alive!!!”

<br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <PreprimarySidebar2025 />
             </Box>
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default KGStoryTelling2025;